import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchSiteIds } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_SITE_IDS } from '@constants/queryKeys';

const useQueryConsistencyCheckSiteIds = (comparisonId: string) => {
	const {
		data: siteIdsOptions,
		isLoading: isLoadingSiteIdsOptions,
		isFetching: isFetchingSiteIdsOptions,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [CONSISTENCY_SITE_IDS, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchSiteIds),
		select: (options) => fieldsOptionsFormatted(options.filter(option => option !== null) || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		siteIdsOptions: siteIdsOptions || [],
		isLoadingSiteIdsOptions: (isLoadingSiteIdsOptions && !!siteIdsOptions)
			|| isFetchingSiteIdsOptions,
	};
};

export default useQueryConsistencyCheckSiteIds;
